/* INT 2026-11-02 OWN WISHLIST, step 1 (task wishlist-own-or-swym, Nils 2026-11-02 16:29 CET: "B Yes make our own please").
   Intention's own wishlist. No Swym. The list lives in localStorage "int-wl-v2" on this device:
     { v:2, c:<customer id or "">, t:<ms>, i:[ { p:<product id>, v:<variant id>, h:<handle>, t:<added ms> } ] }
   Newest first. A heart on a CARD saves the product (its shown variant); the PDP heart saves the chosen variant.
   window.__intWl is the one API every heart, the header heart, the drawer and the wishlist page use:
     has(p) hasPair(p,v) list() count() add({p,v,h}) remove(p[,v]) toggle({p,v,h}) open() close() isOpen()
     known() isReady() start()  (kept so older callers keep working; always true / no-op now)
   Every change fires document event "int:wl" { type:add|remove|sync, item, count }.
   On add, Klaviyo gets "Added to Wishlist" (klaviyo.push track) for identified visitors, so flows can use it.
   int-wl-v1 (the Swym era cache, ids only) is read once as a starting list; items without a handle get it
   the first time a heart for that product is seen.
   STEP 2 2026-11-02 (Nils 18:29 "A - yes"), LOGGED IN SYNC: for a logged in customer snippets/int-wl-server.liquid
   prints window.__intWlSrv = { c:<customer id>, i:<customer metafield int_profile.wishlist> } before this file, so
   the hearts are right on every device with no call. Each change while logged in is queued in localStorage
   "int-wl-q" and sent to /apps/intention/wl (Worker intention-core, the customer id Shopify signs) as small
   add/remove steps; the answer is the stored list. A guest list on this device joins the account at the first
   logged in page; another customer's list on this device is replaced; after sign out the list leaves the device
   (it stays on the account). With no __intWlSrv on the page everything works as in step 1.
   This file is a PLAIN script in the header, so this block runs before DOMContentLoaded. Keep it so. */
(function () {
  if (window.__intWl) return;
  var KEY = 'int-wl-v2', OLD = 'int-wl-v1', MAX = 200;
  var ROOT = String((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var SRV = window.__intWlSrv && window.__intWlSrv.c ? window.__intWlSrv : null;
  var ME = SRV ? String(SRV.c) : '', QK = 'int-wl-q', EP = String(window.__intWlEndpoint || '/apps/intention') + '/wl';
  var owner = '', pend = [];

  function cid() {
    try { var p = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page; if (p && p.customerId) return String(p.customerId); } catch (e) {}
    try { if (window.__st && __st.cid) return String(__st.cid); } catch (e) {}
    return '';
  }
  function handleOf(u) { var m = String(u || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function clean(a) {
    var out = [], seen = {};
    (a || []).forEach(function (x) {
      if (!x) return;
      var p = Number(x.p), v = Number(x.v) || 0;
      if (!p || seen[p + ':' + v]) return;
      seen[p + ':' + v] = 1;
      out.push({ p: p, v: v, h: String(x.h || ''), t: Number(x.t) || Date.now() });
    });
    return out.slice(0, MAX);
  }
  function load() {
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (c && c.v === 2 && Array.isArray(c.i)) { owner = String(c.c || ''); return clean(c.i); }
    } catch (e) {}
    try {
      var o = JSON.parse(localStorage.getItem(OLD) || 'null');
      if (o && Array.isArray(o.i)) return clean(o.i.map(function (x) { return { p: x[0], v: x[1], h: '' }; }));
    } catch (e) {}
    return [];
  }
  var items = load();
  function save() { try { localStorage.setItem(KEY, JSON.stringify({ v: 2, c: owner, t: Date.now(), i: items })); } catch (e) {} }

  /* ── step 2: logged in sync ── */
  function loadQ() {
    try { var q = JSON.parse(localStorage.getItem(QK) || 'null'); if (q && ME && String(q.c) === ME && Array.isArray(q.o)) return q.o.slice(0, 400); } catch (e) {}
    return [];
  }
  function saveQ() { try { if (pend.length) localStorage.setItem(QK, JSON.stringify({ c: ME, o: pend })); else localStorage.removeItem(QK); } catch (e) {} }
  function applyOps(list, ops) {
    var a = list.slice();
    ops.forEach(function (o) {
      var i = -1; for (var k = 0; k < a.length; k++) if (a[k].p === o.p && a[k].v === o.v) { i = k; break; }
      if (o.o === 'a') { if (i > -1) { if (o.h && !a[i].h) a[i] = { p: a[i].p, v: a[i].v, h: o.h, t: a[i].t }; } else a.unshift({ p: o.p, v: o.v, h: o.h || '', t: o.t || Date.now() }); }
      else a = a.filter(function (x) { return !(x.p === o.p && (o.v === null || x.v === o.v)); });
    });
    return a.slice(0, MAX);
  }
  function keyOf(a) { return a.map(function (x) { return x.p + ':' + x.v + ':' + x.h; }).join(','); }
  function queue(o) { if (!ME) return; pend.push(o); saveQ(); flushSoon(); }
  var flushing = false, ft = null;
  function flushSoon(ms) { if (!ME) return; clearTimeout(ft); ft = setTimeout(flush, ms == null ? 350 : ms); }
  function flush() {
    if (!ME || flushing || !pend.length) return;
    flushing = true;
    var sent = pend.slice(0, 50);
    fetch(EP, { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'content-type': 'application/json', 'accept': 'application/json' },
      body: JSON.stringify({ ops: sent.map(function (o) { return o.o === 'a' ? { o: 'a', p: o.p, v: o.v, h: o.h, t: o.t } : { o: 'r', p: o.p, v: o.v }; }) }) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (j) {
        flushing = false;
        if (!j || !Array.isArray(j.items)) return;
        pend = loadQ().slice(sent.length); saveQ();
        var next = applyOps(clean(j.items), pend);
        if (keyOf(next) !== keyOf(items)) { items = next; save(); emit('sync', null); } else { items = next; save(); }
        if (pend.length) flushSoon(0);
      })
      .catch(function () { flushing = false; });
  }
  (function reconcile() {
    if (ME) {
      var srv = clean(Array.isArray(SRV.i) ? SRV.i : []);
      if (owner === ME) { pend = loadQ(); items = applyOps(srv, pend); }
      else if (!owner) {
        /* this device's guest list joins the account */
        pend = [];
        items.slice().reverse().forEach(function (x) {
          var have = false; srv.forEach(function (y) { if (y.p === x.p && y.v === x.v) have = true; });
          if (!have || x.h) pend.push({ o: 'a', p: x.p, v: x.v, h: x.h, t: x.t });
        });
        items = applyOps(srv, pend);
      } else { pend = []; items = srv; }
      owner = ME; save(); saveQ();
      if (pend.length) flushSoon(0);
    } else if (owner && !cid()) {
      /* signed out: the list is safe on the account and leaves this shared device */
      owner = ''; items = []; pend = []; save(); saveQ();
    }
  })();
  window.addEventListener('online', function () { flushSoon(0); });

  function find(p, v) {
    p = Number(p); v = v == null ? null : Number(v);
    for (var i = 0; i < items.length; i++) if (items[i].p === p && (v === null || items[i].v === v)) return i;
    return -1;
  }

  var HEARTS = '.collection-swym-heart[data-product-id],[data-collection-swym-heart][data-product-id],.sa-wl-heart[data-product-id]';
  function paintOne(b) {
    var p = Number(b.getAttribute('data-product-id'));
    var on = find(p) > -1;
    b.classList.toggle('swym-added', on); b.classList.toggle('active', on); b.classList.toggle('is-wishlisted', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on && items[find(p)].h === '') { var h = handleOf(b.getAttribute('data-product-url')); if (h) { var it0 = items[find(p)]; it0.h = h; save(); queue({ o: 'a', p: it0.p, v: it0.v, h: h, t: it0.t }); } }
    var f = b.querySelector('.swym-heart-filled'), o = b.querySelector('.swym-heart-outline');
    if (f && f.hasAttribute('style')) { f.style.display = on ? 'block' : 'none'; if (o) o.style.display = on ? 'none' : ''; }
  }
  function paint(root) { (root || document).querySelectorAll(HEARTS).forEach(function (b) { if (!b.closest('.theme__header')) paintOne(b); }); }
  function setBody() {
    if (!document.body) return;
    var n = items.length > 0;
    document.body.classList.toggle('swym-has-items', n);
    document.body.classList.toggle('int-wl-has-items', n);
  }
  function emit(type, item) {
    setBody(); paint(document); watch();
    try { document.dispatchEvent(new CustomEvent('int:wl', { detail: { type: type, item: item || null, count: items.length } })); } catch (e) {}
  }

  /* Klaviyo "Added to Wishlist": product facts from the store's own /products/<handle>.js, in the shopper's currency. */
  function track(it) {
    if (!it.h || !window.klaviyo) return;
    fetch(ROOT + 'products/' + encodeURIComponent(it.h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (pr) {
        if (!pr) return;
        var v = null; (pr.variants || []).forEach(function (x) { if (x.id === it.v) v = x; });
        v = v || (pr.variants || [])[0] || {};
        var img = (v.featured_image && v.featured_image.src) || pr.featured_image || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var props = {
          ProductID: pr.id, VariantID: v.id, ProductName: pr.title, VariantName: v.title,
          ProductURL: location.origin + ROOT + 'products/' + pr.handle + (v.id ? '?variant=' + v.id : ''),
          ImageURL: img, Price: (v.price || 0) / 100, CompareAtPrice: v.compare_at_price ? v.compare_at_price / 100 : null,
          Currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || '', ProductType: pr.type,
          Tags: pr.tags, Locale: (window.Shopify && Shopify.locale) || '', Source: 'intention_wishlist', ListSize: items.length
        };
        try { window.klaviyo.push(['track', 'Added to Wishlist', props]); } catch (e) {}
      }).catch(function () {});
  }

  function add(x) {
    var p = Number(x && x.p), v = Number(x && x.v) || 0;
    if (!p) return false;
    var h = String((x && x.h) || handleOf(x && x.u) || '');
    var i = find(p, v);
    if (i > -1) { if (h && !items[i].h) { items[i].h = h; save(); queue({ o: 'a', p: p, v: v, h: h, t: items[i].t }); } return true; }
    var it = { p: p, v: v, h: h, t: Date.now() };
    items.unshift(it); items = items.slice(0, MAX); save(); emit('add', it); track(it);
    queue({ o: 'a', p: p, v: v, h: h, t: it.t });
    return true;
  }
  function remove(p, v) {
    var before = items.length, gone = null;
    p = Number(p);
    items = items.filter(function (it) {
      var hit = it.p === p && (v == null || it.v === Number(v));
      if (hit && !gone) gone = it;
      return !hit;
    });
    if (items.length !== before) { save(); emit('remove', gone); queue({ o: 'r', p: p, v: v == null ? null : Number(v) }); }
    return true;
  }
  function toggle(x) {
    var p = Number(x && x.p), v = x && x.v != null ? Number(x.v) : null;
    if (x && x.whole) { if (find(p) > -1) { remove(p); return false; } add(x); return true; }
    if (find(p, v) > -1) { remove(p, v); return false; }
    add(x); return true;
  }

  var drawer = null, wantOpen = false;
  window.__intWl = {
    has: function (p) { return find(p) > -1; },
    hasPair: function (p, v) { return find(p, v) > -1; },
    list: function () { return items.map(function (x) { return { p: x.p, v: x.v, h: x.h, t: x.t }; }); },
    count: function () { return items.length; },
    add: add, remove: remove, toggle: toggle, handleOf: handleOf,
    /* a Swym era item has ids only; any heart that knows the product's URL fills in its handle */
    noteHandle: function (p, u) { var h = handleOf(u), ch = false; if (!h) return; items.forEach(function (it) { if (it.p === Number(p) && !it.h) { it.h = h; ch = true; queue({ o: 'a', p: it.p, v: it.v, h: h, t: it.t }); } }); if (ch) save(); },
    signedIn: function () { return !!ME; }, pending: function () { return pend.length; }, flush: function () { flushSoon(0); },
    open: function () { if (drawer) drawer.open(); else wantOpen = true; },
    close: function () { if (drawer) drawer.close(); },
    isOpen: function () { return !!(drawer && drawer.isOpen()); },
    _setDrawer: function (d) { drawer = d; if (wantOpen) { wantOpen = false; d.open(); } },
    known: function () { return true; }, isReady: function () { return true; }, start: function () {}
  };

  /* Card hearts: one owner, every card (server grid, Searchanise, Pipeline). The whole product is the saved thing. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest(HEARTS) : null;
    if (!b || b.closest('.theme__header') || b.hasAttribute('data-custom-swym-heart')) return;
    e.preventDefault();
    var on = toggle({ p: b.getAttribute('data-product-id'), v: b.getAttribute('data-variant-id'), u: b.getAttribute('data-product-url'), whole: true });
    paintOne(b);
    b.setAttribute('aria-label', on ? (window.__intWlRemoveLabel || b.getAttribute('aria-label')) : (b.getAttribute('title') || b.getAttribute('aria-label')));
  }, false);

  /* Cards drawn later (Searchanise, lazy grids) are painted as they arrive, only while the list has items. */
  var mo = null, mt = null;
  function watch() {
    if (!document.body || typeof MutationObserver === 'undefined') return;
    if (!items.length) { if (mo) { mo.disconnect(); mo = null; } return; }
    if (mo) return;
    mo = new MutationObserver(function () { if (mt) return; mt = setTimeout(function () { mt = null; paint(document); }, 80); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  function boot() { setBody(); paint(document); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('eh:cards:processed', function () { paint(document); });

  /* Another tab changed the list. */
  window.addEventListener('storage', function (e) {
    if (e.key === QK) { pend = loadQ(); return; }
    if (e.key !== KEY) return;
    items = load(); emit('sync', null);
  });
  try { if (!localStorage.getItem(KEY) && items.length) save(); } catch (e) {}
})();


(function() {
  document.addEventListener('click', function(e) {
    var option = e.target.closest('.popout-list__option');
    if (!option) return;
    /* Mark manual currency override so auto-switch doesn't override again */
    try { sessionStorage.setItem('int_currency_override', '1'); } catch(e) {}
    /* Mark clicked option green via inline style (survives any class changes) */
    option.style.color = '#00FFBF';
    option.style.setProperty('color', '#00FFBF', 'important');
    /* Also add a class for CSS hooks */
    option.classList.add('is-loading');
    /* Grey out siblings */
    var siblings = option.parentElement ? option.parentElement.querySelectorAll('.popout-list__option') : [];
    siblings.forEach(function(sib) {
      if (sib !== option) {
        sib.style.setProperty('color', '#999', 'important');
        sib.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  }, false);
})();

;

(function() {
  if (window.__intentionWishlistInit) return;
  window.__intentionWishlistInit = true;
  /* INT 2026-11-02 OWN WISHLIST: the header heart opens or closes Intention's own drawer (assets/int-wishlist-modal.js). */
  window.intentionToggleWishlist = function() {
    var W = window.__intWl;
    if (!W) return;
    if (W.isOpen()) W.close(); else W.open();
  };
  var protectRan = false;
  function protectPosition() {
    var mobile = document.getElementById('intention-wishlist-mobile');
    var desktop = document.getElementById('intention-wishlist-desktop');
    if (mobile) mobile.removeAttribute('style');
    if (desktop) desktop.removeAttribute('style');
    var mobileLeft = document.querySelector('.header__mobile__left');
    var mobileRight = document.querySelector('.header__mobile__right');
    [mobileLeft, mobileRight].forEach(function(container) {
      if (!container) return;
      var swymAnchors = container.querySelectorAll('a[data-swaction], a[href="#swym-wishlist"], a.swym-inject, .swym-inject, [id^="swym-inject"]');
      swymAnchors.forEach(function(a) {
        a.style.cssText = 'display:none!important;visibility:hidden!important;position:absolute!important;left:-9999px!important;width:0!important;height:0!important;';
      });
    });
    // INT 2026-09-08: burger moved to the right cluster, search to the left, so every guard
    // below now runs over BOTH clusters. Nothing here depends on which side an icon sits.
    [mobileLeft, mobileRight].forEach(function(cluster) {
      if (!cluster) return;
      var HIDE = 'display:none!important;visibility:hidden!important;position:absolute!important;left:-9999px!important;width:0!important;height:0!important;';
      var burgerButtons = cluster.querySelectorAll('button[data-drawer-toggle="hamburger"]');
      burgerButtons.forEach(function(btn, index) {
        if (index > 0) {
          btn.style.cssText = HIDE;
        } else {
          var swymInside = btn.querySelectorAll('a, .swym-inject, [id^="swym-inject"]');
          swymInside.forEach(function(el) { el.style.cssText = 'display:none!important;'; });
        }
      });
      // Nuke duplicate #intention-search-mobile buttons (Swym clones the real one)
      var searchButtons = cluster.querySelectorAll('button[id="intention-search-mobile"]');
      searchButtons.forEach(function(btn, index) {
        if (index > 0) {
          btn.style.cssText = HIDE;
        }
      });
      // Also nuke any header button that contains a Swym wishlist injection (these are clones)
      var swymCloneButtons = cluster.querySelectorAll('button > a.swym-wishlist, button > .swym-inject, button > [id^="swym-inject"]');
      swymCloneButtons.forEach(function(swymEl) {
        var parentBtn = swymEl.closest('button');
        if (parentBtn && parentBtn.id !== 'intention-wishlist-mobile') {
          parentBtn.style.cssText = HIDE;
        }
      });
    });
    protectRan = true;
  }
  function scheduleProtect(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 200 });
    } else {
      setTimeout(fn, 50);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scheduleProtect(protectPosition);
    });
  } else {
    scheduleProtect(protectPosition);
  }
  window.addEventListener('load', function() {
    setTimeout(function() {
      protectPosition();
    }, 500);
  });
  var observerStarted = false;
  function startObserver() {
    if (observerStarted) return;
    var mobileLeft = document.querySelector('.theme__header .header__mobile__left');
    var mobileRight = document.querySelector('.theme__header .header__mobile__right');
    if (!mobileLeft && !mobileRight) return;
    observerStarted = true;
    var debounceTimer = null;
    var obs = new MutationObserver(function() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(protectPosition, 80);
    });
    if (mobileLeft) obs.observe(mobileLeft, { childList: true, subtree: true });
    if (mobileRight) obs.observe(mobileRight, { childList: true, subtree: true });
    var mobile = document.getElementById('intention-wishlist-mobile');
    var desktop = document.getElementById('intention-wishlist-desktop');
    var styleObs = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'style') m.target.removeAttribute('style');
      });
    });
    if (mobile) styleObs.observe(mobile, { attributes: true, attributeFilter: ['style'] });
    if (desktop) styleObs.observe(desktop, { attributes: true, attributeFilter: ['style'] });
  }
  window.addEventListener('load', function() {
    setTimeout(startObserver, 300);
  });
})();
